import { Component } from '@angular/core';

@Component({
  selector: 'app-public-pages',
  templateUrl: './public-pages.component.html',
  styleUrls: ['./public-pages.component.scss'],
})
export class PublicPagesComponent {}
